// extracted by mini-css-extract-plugin
module.exports = {"symbolSelect":"styles_symbolSelect__1RbEd"};